'use strict';

const _ = require('lodash');

module.exports = {
    afterConstruction: function () {
        const me = this;
        me.pendingRenderChildViews = [];
    },

    startAsyncRender: function () {
        const me = this;
        me.asyncRenderComplete = false;
        me._pendingAsyncRender = true;

        const parentView = me._parentView();
        if (parentView && parentView.pushPendingRenderChildView) {
            parentView.pushPendingRenderChildView(me);
        }
    },

    stopAsyncRender: function () {
        const me = this;

        me._pendingAsyncRender = false;
        if (me.isAsyncRender() && !me.pendingRenderChildViews.length) {
            me._completeAsyncRender();
        }
    },

    _completeAsyncRender: function () {
        const me = this;

        me.asyncRenderComplete = true;
        me.trigger('render:async');

        const parentView = me._parentView();
        if (parentView && parentView.popPendingRenderChildView) {
            parentView.popPendingRenderChildView(me);
        }
    },

    isAsyncRender: function () {
        const me = this;
        return !_.isUndefined(me.asyncRenderComplete);
    },

    isPendingAsyncRender: function () {
        const me = this;
        return me.asyncRenderComplete === false;
    },

    pushPendingRenderChildView: function (view) {
        const me = this;

        me.pendingRenderChildViews.push(view);

        if (!me.isAsyncRender()) {
            me.startAsyncRender();
            me._pendingAsyncRender = false;
        }
    },
    popPendingRenderChildView: function (view) {
        const me = this;
        me.pendingRenderChildViews = _.without(me.pendingRenderChildViews, view);

        if (!me.pendingRenderChildViews.length && !me._pendingAsyncRender) {
            me._completeAsyncRender();
        }
    },
    _parentView: function () {
        const me = this;

        // If this is a loading view use its hierarchy
        // This prevents force loaded async renders for propagating higher than
        // they should
        if (me._parentLoadingView) {
            if (me._parentLoadingView !== me) {
                return me._parentLoadingView;
            }
            return;
        }

        let parent = me._parent;
        while (parent) {
            if (parent.render) {
                return parent;
            }
            parent = parent._parent;
        }
    }
};
